// 最近观看记录 — localStorage 实现。ulucu 内部 API 没这接口（APK + summary.json 都搜过），
// 是客户端本地概念。每次播放成功 push 一条；最多保留 30 条；带可选 base64 缩略图（jpeg 50% 质量）。

const KEY = 'ulucu.recent_records';
const MAX = 30;

export interface RecentRecord {
	storeId: string;
	storeName: string;
	deviceSn: string;
	deviceLabel: string;
	channel: number;
	viewedAt: number;          // unix ms
	thumbDataUrl?: string;     // 'data:image/jpeg;base64,...'，可选（截 video 当前帧）
	thumbUrl?: string;
	online?: boolean;
}

function read(): RecentRecord[] {
	try {
		const raw = localStorage.getItem(KEY);
		if (!raw) return [];
		const arr = JSON.parse(raw);
		return Array.isArray(arr) ? arr as RecentRecord[] : [];
	} catch { return []; }
}

function write(list: RecentRecord[]) {
	try {
		localStorage.setItem(KEY, JSON.stringify(list));
	} catch {
		// quota 满了 — 砍掉一半重试
		try {
			localStorage.setItem(KEY, JSON.stringify(list.slice(0, Math.floor(list.length / 2))));
		} catch { /* 给放弃 */ }
	}
}

export function getRecentRecords(): RecentRecord[] {
	return read();
}

/** push 一条，按 deviceSn+channel 去重，新的在前 */
export function pushRecentRecord(r: RecentRecord): void {
	if (!r.deviceSn) return;
	const list = read();
	const key = `${r.deviceSn}-${r.channel}`;
	const filtered = list.filter((x) => `${x.deviceSn}-${x.channel}` !== key);
	filtered.unshift(r);
	write(filtered.slice(0, MAX));
}

export function clearRecentRecords(): void {
	try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}

export function deleteRecentRecord(deviceSn: string, channel: number): RecentRecord[] {
	const key = `${deviceSn}-${channel}`;
	const next = read().filter((x) => `${x.deviceSn}-${x.channel}` !== key);
	write(next);
	return next;
}

/** 从 video 元素截当前帧为 jpeg base64（约 30-50KB / 张）。video 没准备好返 undefined。 */
export function captureVideoThumb(video: HTMLVideoElement | null, maxW = 320): string | undefined {
	if (!video || !video.videoWidth || !video.videoHeight) return undefined;
	try {
		const ratio = video.videoWidth / video.videoHeight;
		const w = Math.min(maxW, video.videoWidth);
		const h = Math.round(w / ratio);
		const c = document.createElement('canvas');
		c.width = w; c.height = h;
		const ctx = c.getContext('2d');
		if (!ctx) return undefined;
		ctx.drawImage(video, 0, 0, w, h);
		return c.toDataURL('image/jpeg', 0.5);
	} catch { return undefined; }
}
